import { connect } from 'react-redux';

import LoginForm from './LoginForm.js';
import { redux as apiRedux } from '../api';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};
const mapDispatchToProps = dispatch => {
  const { setUserInfo, setMenuOpenList, clearHeatmapInfo } = apiRedux.actions;
  const {
    clearCurrentInfo,
    setCurrentReportTime,
    nationalDict,
    IDTypeDict,
    cardTypeDict,
  } = apiRedux.actions;
  return {
    onUserInfoUpdated: user => {
      dispatch(setUserInfo(user));
    },
    setMenuOpenList: data => {
      dispatch(setMenuOpenList(data));
    },
    clearHeatmapInfo: data => {
      dispatch(clearHeatmapInfo(data));
    },
    clearCurrentInfo: data => {
      dispatch(clearCurrentInfo(data));
    },
    setCurrentReportTime: data => {
      dispatch(setCurrentReportTime(data));
    },
    setNationalDict: data => {
      dispatch(nationalDict(data));
    },
    setIDTypeDict: data => {
      dispatch(IDTypeDict(data));
    },
    setCardTypeDict: data => {
      dispatch(cardTypeDict(data));
    },
  };
};

const ConnectedLoginForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);

export default ConnectedLoginForm;
